import { Info } from 'react-feather'
import clsx from 'clsx'
import { Tooltip } from '@pepper/ui'

import PercentChange from 'components/PercentChange'

import s from './Stats.module.css'

type StatsBoxProps = {
  title: string
  value: number | string
  percentChange?: number
  subInfo?: React.ReactNode
  statKey?: string
  tooltipText?: string
  isLoading?: boolean
}

const MAX_CHAR_LENGTH = 5

export const StatsBox = ({
  title,
  value,
  percentChange,
  subInfo,
  tooltipText,
  statKey,
  isLoading = false,
}: StatsBoxProps): JSX.Element => {
  const approvalTimeCard = statKey === 'average_approval_time'
  const tooltipPlacement = approvalTimeCard ? 'topRight' : 'top'

  const hasCustomClass =
    approvalTimeCard &&
    typeof value === 'string' &&
    value.length > MAX_CHAR_LENGTH

  return (
    <div className={s.cardBox}>
      <div className={s.cardBoxInner}>
        <div className={s.cardBoxRow}>
          <span className={s.title}>{title}</span>
          {tooltipText && (
            <Tooltip placement={tooltipPlacement} title={tooltipText}>
              <Info size={16} color="var(--color-gray-600)" />
            </Tooltip>
          )}
        </div>
        <div
          className={clsx(s.cardBoxRow, {
            [s.addMargin]: hasCustomClass,
          })}
        >
          <span className={s.figures}>
            {isLoading ? (
              <div className={s.shimmer}></div>
            ) : (
              <span
                className={clsx(s.value, {
                  [s.small]: hasCustomClass,
                })}
              >
                {value}
              </span>
            )}
            {percentChange && <PercentChange change={percentChange} />}
          </span>
          {subInfo}
        </div>
      </div>
    </div>
  )
}
